import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import './style.scss'

const Checkbox = ({ checked, onClick, children }) => {
    const classes = cx({
        'checkbox': true,
        'checkbox--checked': checked
    })

    let flag = checked === true
        ? <div className='checkbox__box__flag' />
        : <span></span>

    return (
        <div className={classes} onClick={() => onClick(!checked)}>
            <div className='checkbox__box'>
                {flag}
            </div>
            <div className='checkbox__label'>
                {children}
            </div>
        </div>
    )
}
Checkbox.propTypes = {
    checked: PropTypes.bool,
    onClick: PropTypes.func,
    children: PropTypes.node
}

export default Checkbox
